module.exports = __webpack_public_path__ + "static/img/sparkly_line.0df6cd07.png";